import { Component, OnInit, Inject } from '@angular/core';
import { ApiService } from '../../services/api/api.service';
import { AuthService } from '../../services/auth/auth.service';
import { ActivatedRoute } from '@angular/router';
import { Data } from '../../models/data';
import { NavController } from '@ionic/angular';
import { count } from 'rxjs/operators';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';

export interface DialogData {
  animal: string;
  name: string;
}

@Component({
  selector: 'app-touchngo',
  templateUrl: './touchngo.page.html',
  styleUrls: ['./touchngo.page.scss'],
})
export class TouchngoPage implements OnInit {

  open(menu)
  {
    menu.openMenu();
  }

  current_year: number = new Date().getFullYear();

  data = new Data();
  myId: any;
  payment = {phone_number: null};
  product: any;
  verify = false;
  active = false;
  select = 0;
  prepaid = '';
  fill = [false, false, false, false, false, false];
  count = 0;
  pass = [];
  character = [1, 2, 3, 4, 5, 6, 7, 8, 9, 'c', 0, 'b'];
  bsubmit = true;
  reloadtype: any;
  myresponse: any;
  radio = [
    /*{
      key: 1,
      label: 'E-Reload'
    },*/
    {
      key: 2,
      label: 'Softpin'
    }];

  constructor(private apiService: ApiService,  private authService: AuthService, private activatedRoute: ActivatedRoute, private navCtrl: NavController, public dialog: MatDialog, private spinner: NgxSpinnerService) {

    this.payment.phone_number = '';
    this.myId = this.activatedRoute.snapshot.paramMap.get('myid');
    this.data =  {
      id: 4,
      name: 'getProduct',
      content: this.myId
    };
    this.reloadtype = 1;

  }

  ngOnInit() {

    this.apiService.postData(this.data).subscribe((response) => {
      this.product = response.data;
      console.log(this.product);
    });

    this.checkActive(1);
  }

  getCatName() {
    if (this.product) {
      return this.product[0].dexpay_label;
    } else {
      return null;
    }
  }

  getProdName() {
    if (this.product) {
      return this.product[0].name;
    } else {
      return null;
    }
  }

  getProdImage() {
    if (this.product) {
      return '/assets/img/' + this.product[0].image;
    } else {
      return null;
    }
  }

  getVariance(id) {
    // console.log(Math.floor(id));
    if (this.product) {
      if ( Math.floor(id) === this.select ) {
        return '/assets/img/RM' + Math.floor(id) + 's.png';
      } else {
        return '/assets/img/RM' + Math.floor(id) + '.png';
      }
    } else {
      return null;
    }
  }

  submit() {
    this.spinner.show();
    // this.navCtrl.navigateForward('/members/success/485');
    /*const passcode =  this.pass[0].toString() + this.pass[1].toString() + this.pass[2].toString() + this.pass[3].toString() + this.pass[4].toString() + this.pass[5].toString();
    console.log(passcode);
    if ( passcode === '123456' ) {*/
    const wallet = localStorage.getItem('wallet');
    const test = wallet.replace(',', '');
    const balance = Number.parseFloat(test) - this.select;

    console.log(test + ' ' + balance);

    if (Number.parseFloat(test) >= this.select ) {

    if (this.reloadtype === 2) {
      this.prepaid = 'Sofpin';
    }
    const dt = {
        mobile: this.prepaid,
        amount: this.select,
        product: this.myId,
        user: localStorage.getItem('user'),
        order: null,
		rrp: this.select
      };

    this.data =  {
        id: 5,
        name: 'addOrder',
        content: dt
      };

    console.log(this.data);
    this.apiService.pay(this.data).subscribe((response) => {
        this.data.content.order = response;
        this.apiService.wallet(this.data).subscribe((res) => {
          this.myresponse = res;
          // let resp = this.myresponse.split('#');
          console.log('azizifairuz');
          console.log(this.myresponse);
          console.log(res);

          if (this.myresponse === 'Failed') {
            this.navCtrl.navigateForward('/members/failed/1');
            // localStorage.setItem('wallet', balance.toString());
            this.spinner.hide();
            console.log(res);
          } else {
            this.navCtrl.navigateForward('/members/success/' + response);
            localStorage.setItem('wallet', balance.toString());
            this.spinner.hide();
            console.log(res);
          }
      });
    });

  } else {
    this.verify = false;
    this.openDialog();
    this.spinner.hide();
  }

  /*  } else {
      console.log ('failed');
    }*/
  }

  verification() {
    this.verify = true;
  }

  setAmount(amt) {

    console.log(this.reloadtype);

    this.select = Math.floor(amt);

    if (this.reloadtype > 0) {
      if (this.reloadtype > 1) {
        this.active = true;
      } else if ( this.prepaid.length >= 10 ) {
        this.active = true;
      } else {
        this.active = false;
      }
    } else {
      this.active = false;
    }
  }

  checkActive(id) {

    this.reloadtype = id;

    console.log(this.prepaid.length + ' ' + this.reloadtype + ' ' + this.select);

    if (this.reloadtype > 0 && this.select > 0) {
      if (this.reloadtype > 1) {
        this.active = true;
      } else if ( this.prepaid.length >= 10 ) {
        this.active = true;
      } else {
        this.active = false;
      }
    } else {
      this.active = false;
    }
  }

  checkInput() {
    console.log(this.prepaid.length + ' ' + this.select);
    if (this.prepaid.length >= 10 && this.select > 0 && this.reloadtype > 0) {
      this.active = true;
    } else {
      this.active = false;
    }
  }

  display(i) {
      if (this.fill[i]) {
        return '../../../assets/img/casterisk.png';
      } else {
        return '../../../assets/img/cblank.png';
      }
  }

  setPass(i) {
    if (i !== 9 && i !== 11) {
      if (this.pass.length <= 5) {
        this.fill[this.count] = true;
        this.pass.push(this.character[i]);
        this.count = this.count + 1;
        console.log(this.pass);
      }
    } else if ( i === 11 ) {
      if (this.pass.length >= 1) {
        this.fill[this.count - 1] = false;
        this.pass.pop();
        this.count = this.count - 1;
        console.log(this.pass);
      }
    } else if ( i === 9 ) {
      if (this.pass.length >= 1) {
        this.fill = [false, false, false, false, false, false];
        this.pass = [];
        this.count = 0;
        console.log(this.pass);
      }
    }

    if (this.pass.length === 6) {
      this.bsubmit = false;
    } else {
      this.bsubmit = true;
    }
  }

  getReloadType() {
    if (this.reloadtype < 2) {
      return 'E-reload';
    } else {
      return 'Softpin';
    }
  }

  getEreload() {
    if (this.reloadtype < 2) {
      return true;
    } else {
      return false;
    }
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DialogTNGPage, {
      width: '280px',
      data: {name: 'name', animal: 'hello'}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  logout() {
    this.authService.logout();
  }


}

@Component({
  selector: 'mydialog',
  templateUrl: 'dialog.html',
})
export class DialogTNGPage {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

}
